export default function useReverseDatepicker(){
    const reverseDatePicker = (date) => {
        let year = date.year;
        let month = date.month < 10 ? `0${date.month}` : date.month;
        let day = date.day < 10 ? `0${date.day}` : date.day;
        return `${year}-${month}-${day}`;
    };

    return { reverseDatePicker };
}